import _ from 'lodash'

import api from '@/api/api'
import Routes from '@/router/routes'

import ScrollTo from '@/components/general/scroll-to/scroll-to'
import MenuMoreOptions from '@/components/general/menu-more-options/menu-more-options'
import TextField from '@/components/general/fields/text/text'
import SelectField from '@/components/general/fields/select/select'

export default {
	name : 'sellers-delegations',
	data () {
		return {
			delegations : [],
			menuOptions : [
				{
					iconClass : 'fa fa-pencil',
					name      : this.$t('private.sellers.delegations.menu_more_options.edit_delegation'),
					action    : 'edit'
				},
				{
					iconClass : 'fa fa-trash',
					name      : this.$t('private.sellers.delegations.menu_more_options.delete_delegation'),
					action    : 'delete'
				}
			],
			filters : {
				name : {
					id      : _.uniqueId('field_'),
					display : true,
					value   : '',
					name    : this.$t('private.sellers.delegations.filters.name'),
					type    : 'text',
					error   : false,
					filters : {
						type      : 'string',
						minLength : 2,
						maxLength : 100,
						required  : true
					},
					style     : {
						width : '230px',
						display : 'inline-block',
						margin : '0px 10px'
					}
				},
				ascending : {
					id        : _.uniqueId('field_'),
					display   : true,
					fakeValue : this.$t('private.sellers.delegations.filters.sort_options.created_at'),
					value     : 'createdAt',
					name      : this.$t('private.sellers.delegations.filters.sort_ascending'),
					error     : false,
					active    : false,
					options : [{
						fakeValue : this.$t('private.sellers.delegations.filters.sort_options.created_at'),
						value : 'createdAt'
					},{
						fakeValue : this.$t('private.sellers.delegations.filters.sort_options.name'),
						value : 'name'
					}],
					style     : {
						width : '230px',
						display : 'inline-block',
						margin : '0px 10px'
					}
				},
				descending : {
					id        : _.uniqueId('field_'),
					display   : true,
					fakeValue : '',
					value     : '',
					name      : this.$t('private.sellers.delegations.filters.sort_descending'),
					error     : false,
					active    : false,
					options : [{
						fakeValue : this.$t('private.sellers.delegations.filters.sort_options.created_at'),
						value : 'createdAt'
					},{
						fakeValue : this.$t('private.sellers.delegations.filters.sort_options.name'),
						value : 'name'
					}],
					style     : {
						width : '230px',
						display : 'inline-block',
						margin : '0px 10px'
					}
				},
				limit : {
					id        : _.uniqueId('field_'),
					display   : true,
					fakeValue : this.$t('private.sellers.delegations.filters.limit_options.10'),
					value     : 10,
					name      : this.$t('private.sellers.delegations.filters.limit'),
					error     : false,
					active    : false,
					options : [{
						fakeValue : this.$t('private.sellers.delegations.filters.limit_options.10'),
						value : 10
					},{
						fakeValue : this.$t('private.sellers.delegations.filters.limit_options.25'),
						value : 25
					},{
						fakeValue : this.$t('private.sellers.delegations.filters.limit_options.50'),
						value : 50
					},{
						fakeValue : this.$t('private.sellers.delegations.filters.limit_options.100'),
						value : 100
					}],
					style     : {
						width : '230px',
						display : 'inline-block',
						margin : '0px 10px'
					}
				},
				skip : {
					value : 0
				}
			},
			getDelegationsActive : false,
			activateFilters : false,
			haveData : false,
			nextPage : false,
			formCreate : {
				fields : {
					name : {
						id      : _.uniqueId('field_'),
						display : true,
						value   : '',
						name    : this.$t('private.sellers.delegations.fields.name'),
						type    : 'text',
						error   : false,
						filters : {
							type      : 'string',
							minLength : 2,
							maxLength : 100,
							required  : true
						}
					}
				},
				active : false
			},
			displayCreateDelegation : false,
			formUpdate : {
				fields : {
					id : {
						value   : '',
						filters : {
							type      : 'string',
							required  : true
						}
					},
					name : {
						id      : _.uniqueId('field_'),
						display : true,
						value   : '',
						name    : this.$t('private.sellers.delegations.fields.name'),
						type    : 'text',
						error   : false,
						filters : {
							type      : 'string',
							minLength : 2,
							maxLength : 100,
							required  : true
						}
					}
				},
				active : false
			},
			displayUpdateDelegation : false
		}
	},
	methods : {
		getDelegations () {

			let vm = this

			vm.getDelegationsActive = true
      vm.delegations = []

			let dataToSend =
				'/?name='      + vm.filters.name.value        +
				'&ascending='  + vm.filters.ascending.value   +
				'&descending=' + vm.filters.ascending.value   +
				'&limit='      + (vm.filters.limit.value + 1) +
				'&skip='       + vm.filters.skip.value

			api
				.delegations
				.getDelegations(dataToSend)
				.then( (response) => {

					vm.getDelegationsActive = false

					if( response.status != 200 ){

						let message = {
							message : [vm.$t('errors.custom.001')],
							type    : 'error'
						}

						vm.$root.$emit('showMessage', message)

						return

					}

					if( !response.data.success ){

						let message = {
							message : [vm.$t('errors.custom.001')],
							type    : 'error'
						}

						vm.$root.$emit('showMessage', message)

						return

					}

					vm.delegations = response.data.delegations

					if( vm.delegations.length > 0 && !vm.haveData ){

						vm.haveData = true

					}

					if( vm.delegations.length > vm.filters.limit.value ){

						vm.nextPage = true

						vm.delegations.pop()

					}else{

						vm.nextPage = false

					}


				})

		},
		goToBackPage () {

			let vm = this

			if( vm.filters.skip.value != 0 ){

				vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value

				vm.getDelegations()

			}

		},
		goToNextPage () {

			let vm = this

			if( vm.nextPage ){

				vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value

				vm.getDelegations()

			}

		},
		optionSelected (data) {

			let vm = this

			if( data.action == 'edit' ){

				vm.formUpdate.fields.id.value   = data.element.id
				vm.formUpdate.fields.name.value = data.element.name

				vm.displayUpdateDelegation = true

			}else if( data.action == 'delete' ){

				vm.deleteDelegation(data.element)

			}

		},
		formCreateSubmit () {

			let vm = this

			if( vm.formCreate.active ){

				return

			}

			vm.formCreate.active = true

			vm.$root.$emit('validate', [vm.formCreate.fields, (response) => {

				if( !response.success ){

					vm.formCreate.active = false

					response.type = 'error'

					response.field.error = true

					let dataToScroll = {
						selector : '#' + response.field.id,
						target   : 'html, body'
					}

					ScrollTo.submit(dataToScroll)

					vm.$root.$emit('showMessage', response)

					return

				}

				let dataToSend = {
					name : vm.formCreate.fields.name.value
				}

				api
					.delegations
					.createDelegation(dataToSend)
					.then( (response) => {

						vm.formCreate.active = false

						if( response.status != 200 ){

							let message = {
								message : [vm.$t('errors.custom.001')],
								type    : 'error'
							}

							vm.$root.$emit('showMessage', message)

							return

						}

						if( !response.data.success ){

							if( response.data.error.code == 101 ){

								let message = {
									message : [vm.$t('errors.parse.101')],
									type    : 'error'
								}

								vm.$root.$emit('showMessage', message)

							}

							return

						}

						let message = {
							message : [vm.$t('private.sellers.delegations.create_success')],
							type    : 'success'
						}

						vm.$root.$emit('showMessage', message)

						vm.getDelegations()

						vm.displayCreateDelegation = false

						vm.formCreate.fields.name.value = ''

					});

			}])

		},
		formUpdateSubmit () {

			let vm = this

			if( vm.formUpdate.active ){

				return

			}

			vm.formUpdate.active = true

			vm.$root.$emit('validate', [vm.formUpdate.fields, (response) => {

				if( !response.success ){

					vm.formUpdate.active = false

					response.type = 'error'

					response.field.error = true

					let dataToScroll = {
						selector : '#' + response.field.id,
						target   : 'html, body'
					}

					ScrollTo.submit(dataToScroll)

					vm.$root.$emit('showMessage', response)

					return

				}

				let dataToSend = {
					id   : vm.formUpdate.fields.id.value,
					name : vm.formUpdate.fields.name.value
				}

				api
					.delegations
					.updateDelegation(dataToSend)
					.then( (response) => {

						vm.formUpdate.active = false

						if( response.status != 200 ){

							let message = {
								message : [vm.$t('errors.custom.001')],
								type    : 'error'
							}

							vm.$root.$emit('showMessage', message)

							return

						}

						if( !response.data.success ){

							if( response.data.error.code == 101 ){

								let message = {
									message : [vm.$t('errors.parse.101')],
									type    : 'error'
								}

								vm.$root.$emit('showMessage', message)

							}

							return

						}

						let message = {
							message : [vm.$t('private.sellers.delegations.update_success')],
							type    : 'success'
						}

						vm.$root.$emit('showMessage', message)

						vm.displayUpdateDelegation = false

						vm.getDelegations()

						vm.formUpdate.fields.name.value = ''

					});

			}])

		},
		deleteDelegation (element) {

			let vm = this

			let questionModal = {
				title : this.$t('private.sellers.delegations.question_modal.title'),
				question : this.$t('private.sellers.delegations.question_modal.question')
			}

			vm.$root.$emit('question-modal', [questionModal, (response) => {

				if(response){

					let dataToSend = '/?id=' + element.id

					api
						.delegations
						.deleteDelegation(dataToSend)
						.then( (response) => {

							vm.formUpdate.active = false

							if( response.status != 200 ){

								let message = {
									message : [vm.$t('errors.custom.001')],
									type    : 'error'
								}

								vm.$root.$emit('showMessage', message)

								return

							}

							if( !response.data.success ){

								if( response.data.error.code == 101 ){

									let message = {
										message : [vm.$t('errors.parse.101')],
										type    : 'error'
									}

									vm.$root.$emit('showMessage', message)

								}

								return

							}

							let message = {
								message : [vm.$t('private.sellers.delegations.delete_success')],
								type    : 'success'
							}

							vm.$root.$emit('showMessage', message)

							vm.getDelegations()

						});

				}

			}])

		}
	},
	components : {
		MenuMoreOptions,
		TextField,
		SelectField
	},
	created () {

		let vm = this

		vm.getDelegations()

	}
}



// WEBPACK FOOTER //
// ./src/components/private/sellers/delegations/script.js